import { useId, useState, type ReactNode } from "react";

/**
 * A macOS-style disclosure section: a triangle, a label, and content that is
 * out of the way until it is wanted. Advanced email settings live behind these
 * so the editor is about writing, not configuration.
 */
export function Disclosure({
  label, summary, defaultOpen = false, children,
}: {
  label: string;
  /** Shown beside the label while collapsed — the current value at a glance. */
  summary?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return (
    <div className="nl-disclosure" data-open={open ? "true" : "false"}>
      <button
        type="button"
        className="nl-disclosure-head"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen((v) => !v)}
      >
        <svg className="nl-disclosure-caret" width="10" height="10" viewBox="0 0 10 10" aria-hidden>
          <path d="M3.5 1.5 L7 5 L3.5 8.5" fill="none" stroke="currentColor" strokeWidth="1.5"
            strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="nl-disclosure-label">{label}</span>
        {!open && summary != null && <span className="nl-disclosure-summary">{summary}</span>}
      </button>
      {open && <div id={id} className="nl-disclosure-body">{children}</div>}
    </div>
  );
}
